import { WILDCARD as n } from "./InputFileUpload.constant.js";
function i(r) {
  return r.reduce((t, e) => t + e.size, 0);
}
function u(r, t) {
  return t.some((e) => e === n ? !0 : r.name.toLowerCase().endsWith(e.toLowerCase()));
}
export {
  i as getTotalFilesSize,
  u as hasValidExtension
};
